"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampleCancellationType = void 0;
var SampleCancellationType;
(function (SampleCancellationType) {
    SampleCancellationType[SampleCancellationType["Winterized"] = 1] = "Winterized";
    SampleCancellationType[SampleCancellationType["Other"] = 128] = "Other";
})(SampleCancellationType = exports.SampleCancellationType || (exports.SampleCancellationType = {}));
//# sourceMappingURL=SampleCancellationType.js.map